import { render, staticRenderFns } from "./ModalChrome.vue?vue&type=template&id=516de92c&scoped=true&"
import script from "./ModalChrome.vue?vue&type=script&lang=js&"
export * from "./ModalChrome.vue?vue&type=script&lang=js&"
import style0 from "./ModalChrome.vue?vue&type=style&index=0&id=516de92c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516de92c",
  null
  
)

export default component.exports